import React, { useState } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Form from '../../components/Form';
import Modal from '../../components/Modal';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import Emailer from '../../components/Emailer';
import ContactsTable from './ContactsTable';
import { handleSubmit, parseContactData } from './utils';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.overview.college-contacts.title',
    defaultMessage: 'Your contacts at {school}',
  },
});

function CollegeContacts({
  open,
  handleClose,
  sendEmail,
  collegeContacts,
  userEmail,
  collegeName,
}) {
  const [subject, updateSubject] = useState('');
  const [body, updateBody] = useState('');
  const [contactId, setContactId] = useState(null);

  const visibleContacts = collegeContacts.filter(c => c.isActive && c.displayOnFc);

  return (
    <Modal
      as={Form}
      open={open}
      onClose={handleClose}
      className="send-to-admissions"
      data-cy="college-contacts"
      size="small"
      onSubmit={() =>
        handleSubmit({
          subject,
          body,
          sendEmail,
          handleClose,
          contactId,
        })
      }
    >
      <Modal.Header>
        <button
          type="button"
          onClick={contactId ? () => setContactId(null) : handleClose}
          className="close-modal"
          aria-label="Close"
        >
          <Icon size="small" name="close" />
        </button>
        <h1 className="title">
          <FormattedMessage
            {...messages.title}
            values={{
              school: collegeName,
            }}
          />
        </h1>
      </Modal.Header>
      <Modal.Content>
        <ContactsTable
          collegeContacts={visibleContacts}
          contactId={contactId}
          onSelectContact={id => setContactId(contactId ? null : id)}
        />
        {contactId ? (
          <Emailer
            userEmail={userEmail}
            admissionsOffice={parseContactData(
              visibleContacts.filter(c => c.id === contactId)[0],
            )}
            onSubjectChange={v => updateSubject(v)}
            onBodyChange={v => updateBody(v)}
            showAddress={false}
          />
        ) : null}
      </Modal.Content>
      {contactId ? (
        <Modal.Actions>
          <Button primary type="submit">
            Submit
          </Button>
        </Modal.Actions>
      ) : null}
    </Modal>
  );
}

CollegeContacts.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sendEmail: PropTypes.func,
  collegeContacts: PropTypes.array,
  userEmail: PropTypes.string,
  collegeName: PropTypes.string,
};

CollegeContacts.defaultProps = {
  collegeContacts: [],
};

export default injectIntl(CollegeContacts);
